import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const PopupWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 0.25em;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${breakpoints.lg}) {
    justify-content: flex-start;
  }
`;

export const DescriptionLabel = styled.div`
  ${theme.typography.labelRegular400}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25em;
  padding: 0.75em 0.5em;
  cursor: pointer;
`;

export const ButtonLabel = styled.div`
  ${theme.typography.labelRegular400}
  text-decoration: underline;
`;
